module.exports = {"id":"231485","name":"Axel Tuanzebe","rating":"73","photo":"./data/images/photos/0/231485.png","club":{"name":"Aston Villa","logo":"./data/images/clubs/AstonVilla.png"},"positions":["DC","MDC","DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AxelTuanzebe0.json
// module id = 503
// module chunks = 0